var React = require( 'react' );
var createReactClass = require('create-react-class');
var DropDownList = require('./dropDownList.jsx');

var MonthPicker = createReactClass({
  getInitialState: function() {
    return {
      months: [
            {"id": 1, "value": "1", "title": "January"},
            {"id": 2, "value": "2", "title": "February"},
            {"id": 3, "value": "3", "title": "March"},
            {"id": 4, "value": "4", "title": "April"},
            {"id": 5, "value": "5", "title": "May"},
            {"id": 6, "value": "6", "title": "June"},
            {"id": 7, "value": "7", "title": "July"},
            {"id": 8, "value": "8", "title": "August"},
            {"id": 9, "value": "9", "title": "September"},
            {"id": 10, "value": "10", "title": "October"},
            {"id": 11, "value": "11", "title": "November"},
            {"id": 12, "value": "12", "title": "December"}
        ]
    };
  },

  render: function(){
    return (
        <DropDownList value={this.props.month} list={this.state.months} onChange={this.props.onMonthChange} />
    );
  }
});

module.exports = MonthPicker;



// WEBPACK FOOTER //
// ./src/common/routes/components/monthPicker.jsx